import { render, staticRenderFns } from "./PruebaNotificacion.vue?vue&type=template&id=3d676b05"
import script from "./PruebaNotificacion.vue?vue&type=script&lang=js"
export * from "./PruebaNotificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports